import React from 'react';
import { ChevronDown, MapPin } from 'lucide-react';
import { useLocationScope } from '../context/LocationContext';

export const NEAR_ME_LABEL = 'Near me (50 mi)';

function MetroSwitcher({ compact = false, variant, className = '' }) {
  const {
    enabledMetros,
    activeMetro,
    metroOverrideId,
    setMetroOverride,
    nearMeSelected,
    enableGpsScope,
  } = useLocationScope();

  const value = metroOverrideId || (nearMeSelected ? 'gps' : activeMetro?.id || 'chicago');
  const onChange = (e) => {
    const next = e.target.value;
    if (next === 'gps') enableGpsScope();
    else setMetroOverride(next);
  };
  const options = (
    <>
      <option value="gps" className="bg-dive-dark">{NEAR_ME_LABEL}</option>
      {enabledMetros.map((metro) => (
        <option key={metro.id} value={metro.id} className="bg-dive-dark">
          {metro.name}
        </option>
      ))}
    </>
  );

  if (variant === 'pill') {
    const label = value === 'gps'
      ? NEAR_ME_LABEL
      : enabledMetros.find((metro) => metro.id === value)?.name || activeMetro?.name || 'Chicago';
    return (
      <label
        className={`relative inline-flex items-center gap-1 rounded-full border border-dive-gray bg-dive-dark/60 pl-2 pr-1.5 py-0.5 text-xs text-gray-300 hover:border-dive-light hover:text-white transition-colors cursor-pointer whitespace-nowrap ${className}`}
      >
        <MapPin className="w-3 h-3 text-dive-neon flex-shrink-0" aria-hidden="true" />
        <span>{label}</span>
        <ChevronDown className="w-3 h-3 text-gray-500 flex-shrink-0" aria-hidden="true" />
        <select
          value={value}
          onChange={onChange}
          aria-label="Choose location"
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        >
          {options}
        </select>
      </label>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <MapPin className="w-4 h-4 text-dive-neon flex-shrink-0" />
      <select
        value={value}
        onChange={onChange}
        aria-label="Choose location"
        className={compact
          ? 'bg-transparent text-white text-sm border-none'
          : 'bg-dive-dark border border-dive-gray rounded-lg px-2 py-2 text-sm text-white'}
      >
        {options}
      </select>
    </div>
  );
}

export default MetroSwitcher;
